export default __webpack_public_path__ + "static/media/LION.72167b64.gif";